import { Component } from '@angular/core';
import { BizService } from 'src/app/services/biz.service';
import {MenuService} from "../../../services/menu-service";

@Component({
    selector: 'app-user-change-password',
    templateUrl: './user-change-password.component.html',
    styleUrls: ['./user-change-password.component.css'],
    standalone: false
})
export class UserChangePasswordComponent {

  oldPasswordIsValid = true;
  newPasswordMatch = true;
  newPasswordIsValid = true;

  email: string = "";
  oldPassword: string = "";
  newPassword: string = "";
  newPasswordRetyped: string = "";

  rememberPassword: boolean = false;

  constructor(private bizService: BizService,
              private menuService: MenuService) {
    this.email = bizService.GetUserEmail();
  }

  //used to show a header (like the one from app-menu) when this component is loaded from the menu
  IsLoadedInMenu() : boolean
  {
    return this.menuService.GetActiveMenuName() == 'Cambio Password';
  }

  async changePassword(email: string, oldPassword: string, newPassword: string) {
    try {
      const success = await this.bizService.UserChangePassword(email, oldPassword, newPassword);
      if (success) {
        // console.log("Password changed successfully");
        return true;
      } else {
        // console.log("Failed to change password");
        return false;
      }
    } catch (error) {
      // console.error("An error occurred while changing the password", error);
      return false;
    }
  }

  async UserChangePassword()
  {
    this.oldPasswordIsValid = true;
    this.newPasswordMatch = true;
    this.newPasswordIsValid = true;

    if (this.newPassword !== this.newPasswordRetyped) { this.newPasswordMatch = false }
    if (this.newPassword === '' ) { this.newPasswordIsValid = false }

    if (this.newPasswordIsValid) {
      // Almeno 8 caratteri, tra cui almeno una lettera maiuscola, almeno una lettera minuscola, almeno un numero, almeno un carattere speciale (@$!%*?&).
      let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
      this.newPasswordIsValid = regex.test(this.newPassword);
    }

    if (this.newPassword === this.newPasswordRetyped && this.newPasswordIsValid)
    {
      this.oldPasswordIsValid = await this.changePassword(this.email, this.oldPassword, this.newPassword);
      if(this.oldPasswordIsValid) {
        this.InitializeValues()
        this.menuService.SetActiveMenuName('Home');
      }
    }
  }

  InitializeValues() {
    this.oldPassword = "";
    this.newPassword = "";
    this.newPasswordRetyped = "";
    this.oldPasswordIsValid = true;
    this.newPasswordMatch = true;
    this.newPasswordIsValid = true;
  }

  UserChangePasswordCancelled()
  {
    this.InitializeValues();
    this.menuService.SetActiveMenuName('Home');
  }
}
